module.exports = __webpack_public_path__ + "img/AFRICA_VEGETABLE_OILS.d79736f8.png";